/* eslint-disable no-unused-expressions */
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
import DeliveryItem from '../../../components/DeliveryItem'
import Pagination from '../../../components/Pagination/Pagination';
import ProgressCircle from '../../../components/ProgressCircle'
import { GetArchDeliveryList } from '../../../services/get-arch-delivery'

const PER_PAGE = 20;

export default function ArchivedDeliveries() {
  const [loading, setLoading] = useState(false);
  const [deliveries, setDeliveries] = useState([]);
  const [count, setCount] = useState(0);
  const { page } = useParams();

  useEffect(() => {
    const loadContent = async () => {
      if (loading)
        return;
      setLoading(true);
      const data = await GetArchDeliveryList(page);
      console.log(data)
      setDeliveries(data.data);
      setCount(data.count);
      setLoading(false);
    };
    loadContent();
    return () => {
      loadContent
    }
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className="container-sm p-4">
        {/* Progress indicator */}
        {loading && <div style={{ width: 'max-content', margin: 'auto' }}>
          <ProgressCircle />
        </div>}
        {/* Content */}
        {deliveries?.map((delivery, index) => {
          return <DeliveryItem
            to={`/arch-delivery/${delivery.order_id}`}
            delivery={delivery}
            key={index} />
        })}
      </div>
      <div className="container-sm p-4">
        <Pagination perPage={PER_PAGE} total={count} url={'/arch-deliveries'} page={page || 1} />
      </div>
    </>
  )
}
